import { Stack, useRouter } from 'expo-router';

import { GenericErrorScreen, RemovePointerEventsOnCommit } from '@fhs/cart';
import { useRumPageView } from '@fhs-legacy/frontend/src/hooks/rum/use-rum-page-view';
import { CartProvider } from '@fhs-legacy/frontend/src/state/cart';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

import { CartHeader, CheckoutHeader } from '../../components/app-header/cart-header';

const CartStack = () => {
  const router = useRouter();
  return (
    <>
      <Stack>
        <Stack.Screen
          name="index"
          options={{
            header: () => <CartHeader href={router.canGoBack() ? '../' : '/menu'} title="Cart" />,
          }}
        />
        <Stack.Screen
          name="payment/index"
          options={{
            header: () => (
              <CheckoutHeader href={router.canGoBack() ? '../' : '/'} title="Checkout" />
            ),
          }}
        />
      </Stack>
      <RemovePointerEventsOnCommit />
    </>
  );
};

const CartPage = () => {
  useRumPageView('cart', 'Cart');

  const enableCartService = useFlag('enable-simply-better-cart-service');

  return (
    <CartProvider>
      {enableCartService ? (
        <GenericErrorScreen>
          <CartStack />
        </GenericErrorScreen>
      ) : (
        <CartStack />
      )}
    </CartProvider>
  );
};

export default CartPage;

export const unstable_settings = {
  initialRouteName: 'index',
};
